import { render, staticRenderFns } from "./notes-warning-modal.vue?vue&type=template&id=3e05c4e7"
import script from "./notes-warning-modal.vue?vue&type=script&lang=ts"
export * from "./notes-warning-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports